import { Container, Title, Text, Grid, GridCol } from '@mantine/core';
import classes from './FeaturesTitle.module.css';
import { ImgComparisonSlider } from '@img-comparison-slider/react';

export function FeaturesTitle() {
  return (
    <Container className={classes.wrapper} size="lg">
      <Grid gutter="xl" align="center">
        {/* Left Column - Image Comparison Slider */}
        <GridCol span={{ base: 12, md: 6 }}>
          <div className={classes.sliderContainer}>
            <ImgComparisonSlider 
              value={50}
              hover={true}
              direction="horizontal"
              className={classes.comparisonSlider}
            >
              <img 
                slot="first" 
                src="/images/menu-before.jpg" 
                alt="Traditional Menu"
                className={classes.sliderImage}
              />
              <img 
                slot="second" 
                src="/images/menu-after.jpg" 
                alt="AI-Processed Menu"
                className={classes.sliderImage}
              />
            </ImgComparisonSlider>
            <Text size="sm" c="dimmed" ta="center" mt="md">
              Drag to compare: Translation Apps vs AI-powered menu
            </Text>
          </div>
        </GridCol>

        {/* Right Column - Japanese Text */}
        <GridCol span={{ base: 12, md: 6 }}>
          <div className={classes.textContent}>
            <Title className={classes.japaneseTitle}>
          ポイント１：日本初めての旅行者でも分かるのメニューを写真から作成できる
            </Title>
            <div className={classes.japaneseDescription}>
              <Text size="lg" c="dimmed" mt="md" mb="md">
                翻訳アプリは誤訳も多く、メニューの内容が正確に伝わらないことがよくあります。そのため、海外のお客様はメニューの内容を完全に理解できず、スタッフも注文を受けるのに苦労することがあります。
            <br />

              
                SmartMenuのAI技術を活用すれば、正確で分かりやすい英語のデジタルメニューを簡単に作成できます。日本食を初めて食べる方でも、料理の内容が一目で分かる自然な説明文を追加することができます。
                <br />              
                英語のデジタルメニュー作成に必要なのは、日本語メニューの写真だけ。面倒なデータ入力は一切不要です。
                <br />              

                お客様は、スマホでQRコードを読み取るだけで、あなたのお店の英語メニューをすぐに閲覧できます。
              </Text>
            </div>
          </div>
        </GridCol>
      </Grid>
    </Container>
  );
} 